import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./create-return-method-onboarding-screen.scss"; 
import FontHeading3 from "../../../../components/fonts/font-heading3/font-heading3";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import OnboardingCustomAddressFields from "./onboarding-custom-address-fields/onboarding-custom-address-fields";
import OnboardingFulfillmentLocationView from "./onboarding-fulfillment-location-view/onboarding-fulfillment-location-view";
import OnlineInventoryAddressesList from "./online-inventory-addresses-list/online-inventory-addresses-list";
import { IStepComponent } from "../../onboarding-page";
import CreateReturnMethodScreenStore from "../../stores/create-return-methods-store";
import { RESTOCK_LOCATION_TAB, RETURN_LOCATION_TAB } from "../../constants";
import OnboardingDefaultNavigationControls from "../onboarding-default-navigation-controls/onboarding-default-navigation-controls";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";
import { useEffect } from "react";
import { Checkbox } from "../../../../components/inputs/checkbox/checkbox";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";

const CreateReturnMethodOnboardingScreen:React.FC<IStepComponent> = observer((props) => {
    const store = props.store as CreateReturnMethodScreenStore;
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';

    const getSubtitleText = () => {

        if (store.isCoveragePlanSelected) {
            return getTranslation('RETURN_METHODS_SCREEN_SUBTITLE_FOR_COVERAGE', scope);
        }

        return getTranslation('RETURN_METHODS_SCREEN_SUBTITLE', scope);
    }

    useEffect(() => {
        store.setDefaults();
    }, [store]);

    return (
        <>
            <div className="create-return-method-onboarding-screen">
                <div className="create-return-method-onboarding-screen-texts">
                    <OnBoardingScreenTitle
                        titleText={getTranslation("RETURN_METHODS_SCREEN_TITLE",scope)}
                        descriptionText={getSubtitleText()}
                        maxWidth={555}
                    />
                </div>

                <div className="return-address-creation-block">
                    <div className="create-return-method-return-address-title">
                        <FontHeading3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("SET_YOUR_RETURN_ADDRESS",scope)}</FontHeading3>
                    </div>

                    <div className="address-type-selectors">
                        <div className={`address-type ${store.addressTab === RETURN_LOCATION_TAB.PLATFORM ? 'selected' : ''}`} onClick={() => store.setAddressTab(RETURN_LOCATION_TAB.PLATFORM)}>
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("ONLINE_INVENTORY",scope)}</FontBody2>
                        </div>
                        <div className={`address-type ${store.addressTab === RETURN_LOCATION_TAB.CUSTOM_ADDRESS ? 'selected' : ''}`} onClick={() => store.setAddressTab(RETURN_LOCATION_TAB.CUSTOM_ADDRESS)}>
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("CUSTOM_ADDRESS",scope)}</FontBody2>
                        </div>
                    </div>

                    {store.addressTab === RETURN_LOCATION_TAB.PLATFORM ?
                        <OnlineInventoryAddressesList locationsList={store.platformLocations} selectedId={store.returnAddressStore.locationId} onSelect={(platformLocation) => store.setReturnAddressLocation(platformLocation)} />
                        : <OnboardingCustomAddressFields store={store} />
                    }

                </div>

                <div className="restock-address-as-return-method-wrapper">
                    <Checkbox
                        label={<FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation("UPDATE_INVENTORY_CONFIRMATION",scope)}</FontBody1>}
                        checked={store.useSameAddressForRestockAddress}
                        disabled={store.isUseSameAddressForRestockAddressDisabled}
                        onChange={(checked: boolean) => store.setUseSameAddressForRestockAddress(checked)} 
                    />
                </div>

                {!store.useSameAddressForRestockAddress &&
                    <div className="restock-location-block">
                        <div className="create-return-method-restock-address-title">
                            <FontHeading3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("SET_YOUR_RESTOCKING_LOCATION",scope)}</FontHeading3>
                        </div>
                        <div className="address-type-selectors">
                                <div className={`address-type ${store.restockAddressTab === RESTOCK_LOCATION_TAB.PLATFORM ? 'selected' : ''}`} onClick={() => store.setRestockAddressTab(RESTOCK_LOCATION_TAB.PLATFORM)}>
                                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("ONLINE_INVENTORY",scope)}</FontBody2>
                                </div>
                                <div className={`address-type ${store.restockAddressTab === RESTOCK_LOCATION_TAB.FULFILLMENT_LOCATION ? 'selected' : ''}`} onClick={() => store.setRestockAddressTab(RESTOCK_LOCATION_TAB.FULFILLMENT_LOCATION)}>
                                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation("FULFILLMENT_LOCATION",scope)}</FontBody2>
                                </div>
                            </div>
                        {store.restockAddressTab === RESTOCK_LOCATION_TAB.PLATFORM ? 
                            <OnlineInventoryAddressesList locationsList={store.platformLocations} selectedId={store.shopifyRestockLocationId} onSelect={(platformLocation) => store.setShopifyRestockLocation(platformLocation)} />
                            : <OnboardingFulfillmentLocationView />
                        }
                    </div>
                }
                <OnboardingWizardStickyFooterPortal>
                    <OnboardingDefaultNavigationControls
                        onBackClick={store.previousStep}
                        isNextDisabled={!store.isComplete()}
                        onNextClick={store.nextStep}
                        isLoading={store.isLoading}
                    />
                </OnboardingWizardStickyFooterPortal>
            </div>
            
        </>
    );
 
});

export default CreateReturnMethodOnboardingScreen;